import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import IndexBloc from "./Blocs/IndexBloc"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    Modal,ModalBody,ModalFooter, ModalHeader,
    FormGroup, FormFeedback, Label
} from "reactstrap"

import TableActiveComponent from './Components/TablePrimaryComponent'
import TableSecondaryComponent from './Components/TableSecondaryComponent'
import moment from 'moment';

const IndexView = (props) => {

    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();
    
    const [nomorSurat, setNomorSurat] = useState("")
    const [nomorSuratValidation, setNomorSuratValidation] = useState(false)
    
    const [modal, setmodal] = useState(false)

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card className="">
                            <CardBody>
                                <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Link to="?create">
                                            <Button color="primary">Tambah Data</Button>
                                        </Link>
                                    : null
                                }
                                
                                </div>
                                <CardTitle>Daftar Pencantuman Gelar</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Pencantuman Gelar
                                </CardSubtitle>
                                <hr />
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                            <span className="d-none d-sm-block">Usul Pentamuman Gelar</span>                                            
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "2",
                                                })}
                                            onClick={() => {
                                                toggle("2")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Data Diproses</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab} className="p-3 text-muted">
                                    <TabPane tabId="1">
                                        <TableSecondaryComponent ref={inactiveRef} handleInactiveSuccess={reloadActiveRef}/>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView